// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bbbced86","453":"b9eb6bfb","455":"cf609fb4","977":"bf1aa039"}[chunkId] + ".chunk.js";
};